import React, { FC } from 'react';
import { BmisAsideDetails, NoBmisAsideDetails } from '@packages/ui/bmis/bmis-aside-details';
import { createUseStyles } from 'react-jss';
import { Typography } from '@packages/ui/shared';
import { useAuthState } from '@packages/contexts/auth';
import { useTranslation } from 'react-i18next';
import colors from '@packages/core/styles/colors';

const useBmisAsideContentStyles = createUseStyles({
    asideHeader: {
        position: 'relative',
        borderBottom: `1px solid ${colors.grayThree}`,
        padding: '16px 24px',
        marginBottom: '16px',
        '&::before': {
            content: '""',
            position: 'absolute',
            bottom: 0,
            left: 24,
            height: '3px',
            width: '60px',
            backgroundColor: colors.blueOne,
        },
    },
});

export const BmisAsideContent: FC = () => {
    const { t } = useTranslation();
    const classes = useBmisAsideContentStyles();
    const { account } = useAuthState();

    return (
        <>
            <div className={classes.asideHeader}>
                <Typography variant="h5" color="blueOne">
                    {t('Details')}
                </Typography>
            </div>
            {account?.bmisCapabilities.canViewTesterDetails ? <BmisAsideDetails /> : <NoBmisAsideDetails />}
        </>
    );
};
